var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#EBF7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7188 9.875C23.2773 9.875 23.75 10.3477 23.75 10.9062V21.2188C23.75 21.8203 23.2773 22.25 22.7188 22.25C22.1172 22.25 21.6875 21.8203 21.6875 21.2188V13.3984L11.7617 23.3242C11.332 23.7539 10.6875 23.7539 10.3008 23.3242C9.87109 22.9375 9.87109 22.293 10.3008 21.9062L20.2266 11.9805H12.4062C11.8047 11.9805 11.375 11.5078 11.375 10.9492C11.375 10.3477 11.8047 9.91797 12.4062 9.91797H22.7188V9.875Z",
    fill: "#74AA85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.106b9002f04e37016650e20fc2020371.svg";
export { ForwardRef as ReactComponent };